import CheckoutCard from 'components/atoms/checkout_card';
import SummaryBuy from 'components/atoms/summary_buy';
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProportionalSaleState } from 'store/modules/proportional_sale_simulation_store/types';
import SubscriptionPayment from '../subscription_payment';
import { Container } from './styles';

const CheckoutData = () => {
  const { proportional_sale } = useSelector<ApplicationState, ProportionalSaleState>(
    (state) => state.session.proportional_sale,
  );

  return (
    <Container>
      <div className="container p-4">
        <div className="row mt-3">
          <div className="col-12 col-md-8">
            <h2>Serviço adicional escolhido</h2>
            <CheckoutCard
              serviceName={proportional_sale?.servicos[0]?.nome}
              serviceDescription={proportional_sale?.servicos[0]?.descricao}
              namePlan={proportional_sale?.servicos[0]?.plano}
              valuePlan={proportional_sale?.servicos[0]?.valor}
              baseValue={proportional_sale?.valor_base}
              finalValue={proportional_sale?.valor_final}
              parcela={5}
              text="Valores aqui apresentados são proporcionais ao tempo restante da sua assinatura."
            />
          </div>
          <div className="col-12 col-md-4">
            <SummaryBuy
              serviceName={proportional_sale?.servicos[0]?.nome}
              finalValue={proportional_sale?.valor_final}
              baseValue={proportional_sale?.valor_base}
              variationValue={proportional_sale?.valor_variacao_forma_pagamento}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-8 mt-5">
            <h2>Pagamentos</h2>
            <SubscriptionPayment
              finalValue={proportional_sale?.valor_final}
              baseValue={proportional_sale?.valor_base}
              additionalValue={proportional_sale?.valor_adicional}
              tradingValue={proportional_sale?.valor_negociacao}
              variationValue={proportional_sale?.valor_variacao_forma_pagamento}
              parcel={proportional_sale?.parcelamento}
              services={proportional_sale?.servico}
              plan_id={proportional_sale?.plano_id}
              update_client_register={false}
              proportional
              list_services={proportional_sale?.servicos}
              type_sale="proporcional"
            />
          </div>
          <div className="col-12 col-md-4 mt-5" />
        </div>
      </div>
    </Container>
  );
};

export default CheckoutData;
